import React from 'react';
import { Grid, TextField, Button } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';

export default function EditDialog({ data, onCreate, onUpdate, handleClose }) {
  const isEdit = !!data;

  const { handleSubmit, control } = useForm({
    defaultValues: {
      name: data?.name || '',
      content: data?.content || '',
    },
  });

  const onSubmit = (values) => {
    const action = isEdit
      ? onUpdate(data.id, values)
      : onCreate(values);

    action.then(() => handleClose());
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2} style={{ minWidth: 400 }}>
        <Grid item xs={12}>
          <Controller
            name="name"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                fullWidth
                variant="outlined"
                label="名稱"
                inputProps={field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="content"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                fullWidth
                variant="outlined"
                label="內容"
                multiline
                rows={4}
                inputProps={field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
          >
            送出
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
